import { SelectedFormatOption } from './reports-page-types'

export const reportFormats: SelectedFormatOption[] = [
  { label: 'TXT', value: '.txt' },
  { label: 'CSV', value: '.csv' },
  { label: 'XML', value: '.xml' },
  { label: 'EXCEL', value: '.xlsx' },
  { label: 'PDF', value: '.pdf' },
]
